import type { InsightChatEvent } from '@wundo/shared/insightChat.ts';

/** Whether something that arrived on a run's socket is an event we know, rather than guessing at its shape. */
export function isInsightChatEvent(
  data: Record<string, unknown>,
): data is InsightChatEvent & Record<string, unknown> {
  if (data.type === 'run_updated') return true;

  if (data.type === 'delta') {
    return typeof data.message_id === 'string' && typeof data.text === 'string';
  }

  return data.type === 'item' && typeof data.item === 'object' && data.item !== null;
}
